import React, { useEffect, useState, useCallback } from 'react';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

import SecondScreen from '../screens/SecondScreen';
import Services from '../screens/Services';
import Projects from '../screens/Projects';
import SketchToReal from '../screens/SketchToReal';
import FAQ from '../screens/FAQ';

import HeroVariants from '../screens/new/HeroVariants';
import QuietLuxury from '../screens/new/QuietLuxury';
import StudioStatement from '../screens/new/StudioStatement';
import TransformationReveal from '../screens/new/TransformationReveal';
import LeadModal from '../screens/new/LeadModal';
import StickyLeadButton from '../screens/new/StickyLeadButton';
import MediaPress from '../screens/new/MediaPress';
import SiteFooter from '../screens/new/SiteFooter';
import NavMenu from '../screens/new/NavMenu';
import LoadingScreen from '../screens/new/LoadingScreen';

export default function NewHome() {
  const [leadOpen, setLeadOpen] = useState(false);
  const openLead = useCallback(() => setLeadOpen(true), []);
  const closeLead = useCallback(() => setLeadOpen(false), []);

  useEffect(() => {
    ScrollTrigger.refresh();
  }, []);

  return (
    <div className="scroll-container">
      <LoadingScreen />
      <HeroVariants onOpenLead={openLead} />
      <QuietLuxury onOpenLead={openLead} />
      <StudioStatement />
      <SecondScreen />
      <Services onOpenLead={openLead} />
      <Projects onOpenLead={openLead} />
      <SketchToReal onOpenLead={openLead} />
      <TransformationReveal onOpenLead={openLead} />
      <MediaPress onOpenLead={openLead} />
      <FAQ onOpenLead={openLead} />
      <SiteFooter onOpenLead={openLead} />

      <NavMenu onOpenLead={openLead} />
      <StickyLeadButton onClick={openLead} />
      <LeadModal open={leadOpen} onClose={closeLead} />
    </div>
  );
}
